export default __webpack_public_path__ + "static/media/Oracle-WindowsTaskScheduler-Action-StartaProgram06.aa37c9ea.png";